import {  NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from '@client';
import {
  AuthUserInterceptor, CacheInterceptorInterceptor,
  PermissionDirectiveModule,
  SharedDataAccessUserModule,
} from '@lcms/shared/data-access-user';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedUiModule } from '@lcms/shared/ui';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { EmptyDashboardComponent } from './modules/_metronic/empty-dashboard/empty-dashboard.component';
import {SharedI18nModule} from "@lcms/shared/i18n";
import {ServiceWorkerModule} from "@angular/service-worker";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {ga_dev} from "../../../../client/src/gtag";

@NgModule({
  declarations: [AppComponent, EmptyDashboardComponent ],
  imports: [
    InfiniteScrollModule,
    SharedUiModule,
    SharedDataAccessUserModule,
    PermissionDirectiveModule,
    BrowserAnimationsModule,
    BrowserModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(appRoutes, {initialNavigation: 'enabledBlocking'}), SharedI18nModule,
    ServiceWorkerModule.register('custom-sw.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthUserInterceptor, multi: true },
    { provide : HTTP_INTERCEPTORS , useClass : CacheInterceptorInterceptor , multi : true},
    {provide: 'googleTagManagerId',  useValue: 	ga_dev.gtmConfig.gtmKey }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
